import { RefObject, useEffect, useRef } from 'react';

export default function useIsIntersectingEffect(
  ref: RefObject<HTMLElement>,
  onChange: (isIntersecting: boolean) => void,
) {
  const callback = useRef(onChange);
  callback.current = onChange;

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => callback.current(entry.isIntersecting));

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [ref]);
}
